module.exports = __webpack_public_path__ + "assets/img/Type E (25).d8cf68e4.jpg";